import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/salesSaga";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const CustomDateRanges = () => {
  const dispatch = useDispatch();

  let { rangeOptions, selectedRangeOption } = useSelector((state) => state.staffSales);
  const { calendarStartDate, calendarEndDate } = useSelector(
    (state) => state.staffSales.currentUser
  );

  let onSelectChange = (data) =>
    dispatch(actionCreators.updateCustomRange({ data, calendarStartDate, calendarEndDate }));

  return (
    <MultiSelectDropdown
      options={rangeOptions}
      selectedFilters={selectedRangeOption}
      includeFilter={false}
      onSelectChange={onSelectChange}
    />
  );
};

export default CustomDateRanges;
